export function convertObjectToFormData(object, Ctr) {
    if (checkIsFormData(object)) {
        return object;
    }
    const form = Ctr ? new Ctr() : new FormData();
    // eslint-disable-next-line guard-for-in
    for (const key in object) {
        form.append(key, object[key]);
    }
    return form;
}
function checkIsFormData(object) {
    return object.constructor?.name === 'FormData';
}
//# sourceMappingURL=convertObjectToFormData.js.map